
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class HSNTaxDetailsGrid extends Serenity.EntityGrid<HSNTaxDetailsRow, any> {
        protected getColumnsKey() { return 'OMS.HSNTaxDetails'; }
        protected getDialogType() { return HSNTaxDetailsDialog; }
        protected getIdProperty() { return HSNTaxDetailsRow.idProperty; }
        protected getInsertPermission() { return HSNTaxDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return HSNTaxDetailsRow.localTextPrefix; }
        protected getService() { return HSNTaxDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}